import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import React, { memo, useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Divider from './Divider'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const xsMatch = useMediaQuery(theme => theme.breakpoints.down('xs'))
  const smMatch = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const initLanguage = useSelector(state => state.user.isLanguageLoaded)
  const { t } = useTranslation()

  const routes = [
    { to: '/terms', name: t('footer.termsOfUse') },
    { to: '/policy', name: t('footer.privacyPolicy') },
    { to: '/cookies', name: t('footer.cookies') },
  ]

  return (
      <>
        {initLanguage && (
            <Box
                component={'footer'}
                p={2}
                pt={8}
                style={{ background: '#171347', color: 'white', marginTop: 'auto' }}
            >
              <Container>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={7}>
                    <Typography
                        variant={'h6'}
                        style={{ opacity: 0.8, color: 'white', ...(xsMatch && { textAlign: 'center' }) }}
                    >
                      <strong>
                        {t('footer.createChurchPrompt')}
                      </strong>
                    </Typography>
                  </Grid>
                  <Grid
                      item
                      xs={12}
                      sm={5}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        ...(xsMatch && { justifyContent: 'center' }),
                      }}
                  >
                    <Button component={RouterLink} to={`/contact?order=${new Date().getTime()}`}>
                      {t('footer.orderService')}
                    </Button>
                  </Grid>
                </Grid>
                <Divider style={{ margin: '1.5rem 0' }} />
                <Grid container {...(smMatch && { wrap: 'wrap-reverse' })} spacing={2}>
                  <Grid
                      item
                      xs={12}
                      md={6}
                      style={{ ...(smMatch && { display: 'flex', justifyContent: 'center' }) }}
                  >
                    <Typography variant={'caption'} style={{color: 'white'}}>
                      <strong> &copy; ReligionPeace, {new Date().getFullYear()}. </strong>{t('footer.allRightsReserved')}
                    </Typography>
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <nav>
                      <List
                          style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', padding: 0 }}
                      >
                        {routes.map(({ to, name }, i) => (
                            <ListItem key={i} style={{ width: 'auto', paddingTop: 0, paddingBottom: 0 }}>
                              <ListItemText>
                                <Link
                                    underline={'hover'}
                                    component={RouterLink}
                                    to={to}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                  {name}
                                </Link>
                              </ListItemText>
                            </ListItem>
                        ))}
                      </List>
                    </nav>
                  </Grid>
                </Grid>
              </Container>
            </Box>
        )}
      </>
  )
}

export default memo(Footer)
